<app-help-page mainVideo="organic-sources"
               [tutorials]="['organic-sources']"
               [videos]="['organic-sources', 'add-an-automatic-data-source', 'custom-data-sources', 'add-an-analytics-data-source']"></app-help-page>
